<template>
  <div class="main-content">
    <div class="section__content section__content--p30">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="overview-wrap m-b-40">
              <h2 class="title-1">{{ text('Endpoints') }}</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive m-b-40">
              <div class="el-loading-mask" v-if="loading">
                <div class="el-loading-spinner">
                  <svg viewBox="25 25 50 50" class="circular">
                    <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                  </svg>
                </div>
              </div>
              <table class="table table-borderless table-endpoints">
                <thead>
                <tr>
                  <th>{{ text('title') }}</th>
                  <th>URL</th>
                  <th>{{ text('status') }}</th>
                  <th>{{ text('updated') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="(endpoint, i) of endpoints"
                  :key="i"
                  @click="showEndpointInfo(endpoint.id)"
                >
                  <td class="desc">{{ endpoint.name }}</td>
                  <td><span class="blocked-text">{{ endpoint.url }}</span></td>
                  <td>
                    <span v-if="!endpoint.disabled">
                        <i class="fa fa-exclamation-circle job-status--failed"
                           v-if="endpoint.state === 'error'">
                        </i>
                        <i class="fa fa-check-circle job-status--finished"
                           v-else-if="endpoint.state === 'ok'">
                        </i>
                        <i class="fa fa-clock job-status--paused"
                           v-else>
                        </i>
                        {{ endpoint.state }}
                      </span>
                    <span v-else>
                        <i class="fa fa-stop-circle job-status--failed"></i>
                        {{ text('disabled') }}
                    </span>
                  </td>
                  <td>{{ lastUpdateTime(endpoint.updated) }}</td>
                </tr>
                <tr v-if="!loading && !endpoints.length">
                  <td class="text-center" colspan="4">
                    <div class="m-b-15 m-t-15">
                      {{ text('no_cdn_text') }}
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { JsonAPIEndpointToNorm } from '@/components/cdn/shared/converter';

export default {
  created() {
    this.$store.commit('setPageLoader');
    this.$store.dispatch('endpoints/getCDNEndpoints')
      .then((endpoints) => {
        this.endpoints = endpoints.map(e => JsonAPIEndpointToNorm(e));
      })
      .catch((errorMsg) => {
        this.$toasted.error(errorMsg, {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 10000,
        });
      })
      .finally(() => this.$store.commit('resolvePageLoader'));
  },
  data() {
    return {
      endpoints: [],
    };
  },
  computed: {
    loading() {
      return this.$store.getters.isDataLoaded;
    },
    dict() {
      return this.$store.getters.dictionary;
    },
  },
  methods: {
    showEndpointInfo(id) {
      this.$router.push({
        name: 'EndpointDetailPage',
        params: {
          id,
        },
      });
    },
    lastUpdateTime(lastUpdateTime) {
      return moment(lastUpdateTime).fromNow();
    },
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return code;
    },
  },
};
</script>
